const classNames = (...names: (string | null | undefined)[]): string =>
    names.length < 1 ? '' : names.filter(Boolean).join(' ');

export default classNames;
